import { getError } from "./error";


export  const fetchDomains = async({setDomains,getDomains,params})=>{
    try {
        const data = await getDomains(params).unwrap();
        setDomains(data?.domains);
    } catch (error) {
        getError(error)
    }
}
export  const fetchSubdomains = async({setSubdomains,id,getSubdomains,params})=>{
        try {
          const data = await getSubdomains({id,params}).unwrap();
          setSubdomains(data?.subDomains);
        } catch (error) {
          getError(error)
        }
      }

export  const fetchTopics = async({setTopics,id,getTopics,params})=>{
    try {
        const data = await getTopics({id,params}).unwrap();
        setTopics(data?.topics);
    } catch (error) {
        getError(error)
    }
}
export  const fetchSubtopics = async({setSubtopics,id,getSubtopics,params})=>{
        try {
          const data = await getSubtopics({id,params}).unwrap();
          setSubtopics(data?.subTopics);
        } catch (error) {
          getError(error)
        }
      }


   export   const fetchQuestions = async({getQuestions,setQuestions,query,status,topic,subdomain,id})=>{
        try {
          // console.log(query,status,topic,subdomain,id)
          const params = `key=${query}`
          const data = await getQuestions({id,params,status,subdomain,topic}).unwrap();
          setQuestions(data?.questions);
        } catch (error) {
          getError(error)
        }
       }
        


